import { createSelector } from 'reselect';
import constants from './constants';

const selectAccessUrlsState = (state) => state[constants.NAME];

const selectAccessUrlsById = createSelector([selectAccessUrlsState], (accessUrls) => accessUrls.accessUrlsById);

const getAccessUrlIdParam = (_, id) => id;

const selectAccessUrl = createSelector(
  [selectAccessUrlsById, getAccessUrlIdParam],
  (accessUrlsById, id) => accessUrlsById && accessUrlsById[id],
);

export default {
  selectAccessUrlsById,
  selectAccessUrl,
};
